<template>
	<a v-bind:href="item.Url"
			@click="eventClick(item)"
			v-bind:target="item.IsExternal ? '_blank' : '_self'" 
			class="card card-event card-event--item">
		<div class="card-content">
			<div class="card-content-title">
				<div class="card-event-featured" v-if="item.IsFeatured">Featured</div>
				<div class="card-content-title-wrap">
					<h3 v-if="item.Title">{{ item.Title }}</h3>
					<div v-if="item.Description" v-html="item.Description"></div>
				</div>
			</div>
		</div>
	</a>
</template>

<script>
	import DateFormatService from '../../services/date-format.service';
	import analytics from '../../utils/analytics';

	export default {
		props: ['item', 'showctatext'],
		components: {

		},
		mounted: function () {

		},
		methods: {
			formatDay(date) {
				return DateFormatService.formatDay(date);
			},
			formatMonth(date) {
				return DateFormatService.formatMonth(date);
			},
			formatDateRange(start, end) {
				return DateFormatService.formatDateRange(start, end);
			},
			eventClick(item) {
				let data = {
					full_event_name: item.Title,
					event_date: item.DateDisplay,
					event: item.EventName,
					location: `${item.City}, ${item.State}`
				};
				analytics.viewEventDetailsClick(data);
			}
        },
    }
</script>